import axios from '../../http'

class DBMall {
  // 导航栏--查询所有专栏
  getColumnList() {
    let url = `/api/top/module/search`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 导航栏--新增专栏
  addColumn(data) {
    const url = `/api/top/module/add`
    console.log('数据--', data)
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 导航栏--更新专栏
  updateColumn(data) {
    const url = `/api/top/module/modify`
    console.log('数据--', data)
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 导航栏--删除专栏
  deleteColumnById(columnId) {
    const url = `/api/top/module/delete?id=${columnId}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 导航栏--根据专栏id获取专栏的详细信息
  getColumnInfoById(columnId) {
    const url = `/api/top/module/search/by?id=${columnId}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 导航栏--根据模块id和专栏id，删除某专栏的某模块
  deleteModuleInColumn(moduleId, columnId) {
    const url = `/api/top/module/info/delete?id=${moduleId}&moduleId=${columnId}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 导航栏--某专栏新增模块
  addModuleForColumn(data) {
    const url = `/api/top/module/info/add`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 导航栏--更新某专栏的模块详情
  updateModuleForColumn(data) {
    const url = `/api/top/module/info/modify`
    console.log('在更新某专栏的模块详情')
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 大B--客户标签列表
  getDBClientTagList(currentPage) {
    const url = `/api/db/cus/label/list?currentPage=${currentPage}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB查看侧边栏
  postDBSide() {
    const url = `/api/left/module/list`
    return axios.post(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB添加侧边栏
  postDBAddSide(cateIds) {
    const url = `/api/left/module/add`
    const data = {
      cateIds
    }
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB删除侧边栏
  postDBDeleteSide(id) {
    const url = `/api/left/module/del`
    const data = {
      id
    }
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB查看底部栏
  postDBBottom() {
    const url = `/api/bottom/module/list`
    return axios.post(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB底部栏添加一级大类
  postDBAddBottom(name) {
    const url = `/api/bottom/module/add`
    const data = {
      name
    }
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB底部栏添加二级大类
  postDBBottomInfo(moduleId, title) {
    const url = `/api/bottom/module/info/add`
    const data = {
      moduleId,
      title
    }
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB修改一级大类
  postDBUpdateBottom(id, name) {
    const url = `/api/bottom/module/update`
    const data = {
      id,
      name
    }
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB删除底部栏
  postDBDeleteBottom(id) {
    const url = `/api/bottom/module/del`
    const data = {
      id
    }
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB查看底部栏详情
  postDBDetailBottom(id) {
    const url = `/api/bottom/module/info/detail`
    const data = {
      id
    }
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB更新底部导航文章
  postDBUpdateBottomInfo(id, title, info) {
    const url = `/api/bottom/module/info/update`
    const data = {
      id,
      title,
      info
    }
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB删除二级类
  postDBDeleteBottomInfo(id) {
    const url = `/api/bottom/module/info/del`
    const data = {
      id
    }
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB获取客服数据
  getDBCusservice() {
    const url = `/api/cusservice/list`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB添加客服
  postDBAddCusservice(data) {
    const url = `/api/cusservice/add`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB删除客服
  postDBDeleteCusservice(id) {
    const url = `/api/cusservice/delete`
    let data = {
      id
    }
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB修改客服
  postDBUpdateCusservice(data) {
    const url = `/api/cusservice/update`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB修改手机banner
  postDBUpdateBanner(data) {
    const url = `/api/mall/setting/banner/modify`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB获取手机banner
  getDBBannerList() {
    const url = `/api/mall/setting/banner/list`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB商城top排序
  getDBMallTopSort(data) {
    const url = `/api/top/module/order`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB自定义页面添加模块
  postDBAddCustomize(data) {
    const url = `/api/activity/save`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB获取预览数据
  getDBCustomizeData() {
    const url = `/api/activity/list`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB自定义页面删除模块
  postDBDeleteCustomize(data) {
    const url = `/api/activity/del`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB自定义页面模块排序
  postDBSortCustomize(data) {
    const url = `/api/activity/update/sort`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // DB自定义页面模块排序
  postDBUpdateCustomize(data) {
    const url = `/api/activity/update`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 修改导航栏排序
  postDBUpdateSort(data) {
    const url = `/api/top/module/info/modify/order/num`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default DBMall
